import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs/internal/Subscription';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { CommonModule } from '@angular/common';
import { JsonDataService } from '../../../shared/services/json-data.service';
import { MetaMgmtService } from '../../../shared/services/meta-mgmt.service';
import { StaticPagesService } from '../../../shared/services/static-pages.service';
import { UtilsService } from '../../../shared/services/utils.service';
@Component({
  selector: 'app-installation',
  templateUrl: './installation.component.html',
  styleUrls: ['./installation.component.scss'],
  standalone:true,
  imports:[CommonModule]
})
export class InstallationComponent implements OnInit,OnDestroy {
  staticPageResponse: any = [];
  pageName: any = 'installation';
  sub:Subscription=new Subscription()
  constructor(private service: StaticPagesService,
    public utils: UtilsService, private route: ActivatedRoute,
    private metaSvc: MetaMgmtService, private sanitizer: DomSanitizer,
    private jsonDataService: JsonDataService,
    private router: Router) {
    this.utils.showHeaderFooter.next(true);
    this.sub.add(this.jsonDataService.getMetaDataJsonData().subscribe({
      next: (res: any) => {
        this.utils.hideLoading()
        const activeRouter = this.utils.getActiveRouter(this.router.url);
        const metaDataFilter = res.find((x: any) => activeRouter === x.name);
        let metaData = {
          canonicalURL: metaDataFilter?.canonicalUrl || '',
          description: metaDataFilter?.description || '',
          pageTitle: metaDataFilter?.title || '',
        };
        this.metaSvc.updateMetaTags(metaData);    
    },
    error: (err: any) => {
      this.utils.hideLoading()
      console.error('Error fetching meta data', err);
    }}));
  }

  ngOnInit(): void {
    this.sub.add(this.service.getStaticPageByName({ pageName: this.pageName }).subscribe(
      (response: any) => {
        this.utils.hideLoading();
        if (response.success) {
          this.staticPageResponse = response.staticPageDataResponses;
        }
        else if (!response.success) {
          this.utils.openSnackBar(response.message, 'error-toster')
        }
      }
    ))
  }

  getSafeVideoUrl(url: string): SafeResourceUrl {
    return this.sanitizer.bypassSecurityTrustResourceUrl(url);
  }

  ngOnDestroy(): void {

    this.sub.unsubscribe()
  }
}
